module.exports = __webpack_public_path__ + "static/img/05-add-app-manual.0fc585f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-setup-guide/05-add-app-manual.png
// module id = L8WA
// module chunks = 1